import { observer } from 'mobx-react-lite';
import { CSSProperties } from 'react';
import { usePluginStore } from '../../../store/RootStoreContext';
import { TAB_BAR_HEIGHT } from '../../../styles/theme';

/**
 * @param {string} pluginId - to get plugin definition from store
 * @returns an iframe with src read from plugin definition
 */

const styles = {
    iframe: {
        position: 'fixed',
        top: TAB_BAR_HEIGHT,
        height: `calc(100vh - ${TAB_BAR_HEIGHT}px)`,
        overflowY: 'auto'
    } as CSSProperties
};

export default observer(function PagePlugin({ pluginId, rootClassName }: { pluginId: string; rootClassName: string }) {
    const { pagePlugins } = usePluginStore();
    const pluginDefinition = pagePlugins[pluginId];
    // const pluginName = pluginDefinition?.name;

    if (!pluginDefinition) return null;

    const iFrameSource = `${pluginDefinition.manifest.src}`;

    return (
        <div className={rootClassName}>
            <iframe
                // id={`${pluginDefinition.pluginId}`}
                className="full-width"
                style={styles.iframe}
                src={iFrameSource}
            />
        </div>
    );
});
